import React, {useEffect, useState} from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import {ReportForm, schoolYears} from "../../components";
import {NumberInput, required, Title} from 'react-admin';
import env from "../../env/env";
import {downloadFilePost} from "../../components/FileDownload";
import TreeCheckBoxCustomInput from "../../components/TreeCheckBoxCustomInput";
import cachedApis from "../../api/cachedApis";

const BcLyLichNangKhieu = () => {
    const [formState, setFormState] = useState({
        fromStt: 1,
        toStt: 100
    });
    const [customerIds, setCustomerIds] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        getCustomersWithUnits();
    }, []);

    function getCustomersWithUnits() {
        cachedApis.getCustomerUnits(true, schoolYears[0].id).then(rs => {
            setCustomers(rs);
        })
    }

    const docReport = async () => {
        setLoading(true)
        const data = {
            ...formState,
            customerIds
        };
        await downloadFilePost(`${env.baseURL}/reports/bc-ly-lich-nang-khieu`, 'bc_ly_lich_nang_khieu.docx', data)
        setLoading(false)
    };

    const validate = (values) => {
        const errors = {};
        setFormState(prev => ({
            ...prev,
            ...values
        }));

        return errors;
    };

    function onStudentSelected(value) {
        const studentIds = [];
        const oldEnrollUnitIds = [];
        value.forEach(i => {
            const temp = "" + i;
            let zeroIdx = temp.indexOf("0000");
            let lastZeroIdx = -1;
            while (zeroIdx >= 0) {
                lastZeroIdx = zeroIdx;
                zeroIdx = temp.indexOf("0000", zeroIdx + 1);
            }
            if (lastZeroIdx != -1 && lastZeroIdx < temp.length - 1) {
                let stdId = Number(temp.substr(lastZeroIdx + 4));
                let unitId = Number(temp.substr(0, lastZeroIdx));
                if (!studentIds.includes(stdId)) {
                    studentIds.push(stdId);
                }
                if (!oldEnrollUnitIds.includes(unitId)) {
                    oldEnrollUnitIds.push(unitId);
                }
            }
        });
        setCustomerIds(studentIds);
    }

    return (
        <Card>
            <Title title="resources.bc-ly-lich-nang-khieu.name"/>
            <CardContent>
                <ReportForm
                              params={{...formState, customerIds}}
                    validate={validate}
                              docReport={docReport}
                    isLoading={loading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <NumberInput label="resources.bc-ly-lich-nang-khieu.fromStt" source="fromStt"
                                         validate={required()}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <NumberInput label="resources.bc-ly-lich-nang-khieu.toStt" source="toStt"
                                         validate={required()}/>
                        </Grid>
                    </Grid>
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6} style={{maxHeight: '450px', paddingRight: '16px'}}>
                            <label style={{color: 'rgba(0, 0, 0, 0.54)', fontSize: '1rem'}}>
                                Chọn Học sinh
                            </label>
                            <div style={{maxHeight: '400px', overflow: 'auto'}}>
                                <TreeCheckBoxCustomInput data={customers}
                                                         selected={customerIds}
                                                         expandTopLevel={true}
                                                         onChange={onStudentSelected}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default BcLyLichNangKhieu

